<template>
  <div class="">
    <div v-if="loading.load">
      Загрузка...
      <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
    </div>
    <div v-else>
      <div v-if="!aiExpertEnabled" class="mb-3">
        Подключите расширенный пакет услуг и получите рекомендации от виртуального AI-эксперта.
      </div>
      <div class="row mb-1">
        <div class="col col-12 col-md-9">
          <ChatPanel class="mb-3" :class="{'chat-panel-elevated': !fromMainMenu}"/>
          <v-row class="my-3" dense>
            <transition-group name="fly" tag="div" class="mt-3 d-flex flex-wrap">
            <FileBadge v-for="(file, index) in pendingFiles" :key="file.id+file.name+index"
              :closable="!file.sending && !file.sended"
              @close="removePendingFile(index)"
              :loading="file.sending"
              :loaded="file.sended"
              :error="file.error"
              :name="file.name"
              class="ma-1"
            />
            </transition-group>
          </v-row>
          <div class="d-flex">
            <v-textarea
              :class="{disabled: !aiExpertEnabled}"
              v-model="message" outlined dense auto-grow :rows="1" type="text" hide-details class="input-message"
              label="Введите запрос или выберите подходящий вариант" :disabled="!aiExpertEnabled || !!lastMsgThinking"
            >
              <template v-slot:append>
                <img src="@/assets/images/ai-expert/attach.svg" class="icon-load-file" @click="selectFiles()">
                <!-- <v-tooltip bottom >
                  <template v-slot:activator="{ on }">
                    <img v-on="on" src="@/assets/images/ai-expert/attach.svg" class="icon-load-file" @click="selectFiles()">
                  </template>
                  Загрузка файла
                </v-tooltip> -->
              </template>
            </v-textarea>
            <input ref="fileInput" type="file" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.txt" style="display: none" @change="handleFiles" />
            <v-btn dense color="primary" class="send-button" :disabled="!aiExpertEnabled || !message" @click="onAddMessage()">
              Отправить
            </v-btn>
          </div>
        </div>
        <div class="col col-12 col-md-3 pr-4">
          <!-- <div class="ai-btn mb-4 w-100" v-ripple :class="{disabled: !aiExpertEnabled || !chat || chat.length===0}" @click="newChat()">
            <img src="@/assets/images/ai-expert/new-chat.svg">Новый чат
          </div> -->
          <ChatsHistory />
        </div>
      </div>

      <div class="d-flex">
        <div class="ai-btn small mb-4 mr-4" v-ripple :class="{disabled: !aiExpertEnabled}" @click="showPromptsDialog=true">
          <img src="@/assets/images/ai-expert/requests.svg">Готовые запросы
        </div>
        <div v-if="fromMainMenu" class="ai-btn small mb-4 mr-4" v-ripple :class="{disabled: !aiExpertEnabled}" @click="showSelectCandidateDialog=true">
          <img src="@/assets/images/ai-expert/candidate-choise.svg">Выбрать кандидата
        </div>
        <div v-if="fromMainMenu && $store.getters['auth/isAllowed']('ai_edit_system_prompt')" class="ai-btn small mb-4" v-ripple @click="showSystemPpromptDialog=true">
          Cистемный промпт
        </div>
      </div>
      <div class="d-flex flex-wrap mb-3">
        <div v-for="tag in tags" :key="tag.title" class="tag-item" v-ripple :class="{disabled: !aiExpertEnabled || !!lastMsgThinking}" @click="onAddShortCut(tag.id)">
          {{ tag.title }}
        </div>
      </div>
    </div>
    <SelectCandidateDialog v-model="showSelectCandidateDialog" />
    <PromptsDialog v-model="showPromptsDialog" @ok="onAddPromptContent($event)"/>
    <SendingDialog />
    <SystemPromptEditDialog v-model="showSystemPpromptDialog" />
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ChatPanel from './ChatPanel.vue'
import ChatsHistory from './ChatsHistory.vue'
import SelectCandidateDialog from './SelectCandidateDialog.vue'
import SystemPromptEditDialog from './SystemPromptEditDialog.vue'
import PromptsDialog from './PromptsDialog.vue'
import SendingDialog from './SendingDialog.vue'
import FileBadge from '@/components/ui/FileBadge.vue'

export default {
  name: 'Analytics',
  components: {
    ChatPanel, ChatsHistory, SelectCandidateDialog, PromptsDialog, FileBadge, SendingDialog, SystemPromptEditDialog
  },
  props: {
    fromMainMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: '',
      showSelectCandidateDialog: false,
      showPromptsDialog: false,
      showSystemPpromptDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      aiExpertEnabled: 'ai/expert/enabled',
      tags: 'ai/prompts/tags',
      chat: 'ai/expert/chat',
      loading: 'ai/prompts/loading',
      lastMsgThinking: 'ai/expert/lastMsgThinking',
      pendingFiles: 'ai/dossier/pendingFiles',
    }),
  },
  methods: {
    ...mapActions({
      addUserMessage: 'ai/expert/addUserMessage',
      loadChats: 'ai/expert/loadChats',
      loadPrompts: 'ai/prompts/loadPrompts',
      loadPromptStd: 'ai/prompts/loadPromptStd',
    }),
    ...mapMutations({
      addPendingUserFile: 'ai/dossier/addPendingUserFile',
      removePendingFile: 'ai/dossier/removePendingFile',
    }),
    onAddMessage() {
      if (this.lastMsgThinking)
        return;
      const response = this.addUserMessage(this.message)
      if (response)
        this.message = ''
    },
    async onAddShortCut(id) {
      if (this.lastMsgThinking)
        return;
      const prompt = await this.loadPromptStd(id)
      this.addUserMessage(prompt.content)
    },
    onAddPromptContent(text) {
      if (this.lastMsgThinking)
        return;
      this.addUserMessage(text)
    },
    selectFiles() {
      this.$refs.fileInput.click()
    },
    handleFiles(event) {
      const files = Array.from(event.target.files)

      for (const f of files) {
        if (!(f.name.endsWith('.xlsx') || f.name.endsWith('.docx') || f.name.endsWith('.doc') || f.name.endsWith('.pdf') || f.name.endsWith('.txt'))) {
          this.$toast.error("Выберите файл формата DOCX, XLSX, или PDF", '', { position: 'topRight' });
          continue
        }
        // if (f.size >= 21000000) {
        //   this.$toast.error("Размер файла не должен быть более 20 Мб", '', { position: 'topRight' });
        //   continue
        // }
        this.addPendingUserFile(f)
      }
      event.target.value = ''
    },
  },
  async mounted() {
    this.loadChats()
    this.loadPrompts()
  },
  beforeDestroy() {}
};
</script>

<style _scoped lang="scss">
@import "src/assets/styles/variables";

.ai-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 12px;
  gap: 8px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05), 2px 0px 4px rgba(0, 0, 0, 0.05), -2px 0px 2px rgba(3, 3, 15, 0.05);
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  transition: all ease 0.2s;

  &.small {
    padding: 7px 12px;
    gap: 4px;
    border: 1px solid #E4E4E4;
    border-radius: 12px;
    font-size: 0.8rem;
    box-shadow: none;
  }
  &:hover:not(.disabled) {
    background: $color-white-hover;
  }
  &.disabled {
   background: $color-disabled;
   cursor: inherit;
  }
}

.tag-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  height: 24px;
  background: #E4E4E4;
  border-radius: 12px;
  margin: 0 20px 16px 0;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all ease 0.2s;
  &:hover:not(.disabled) {
    background: #f0f0f0;
  }
  &.disabled {
    cursor: initial;
  }
}

.icon-load-file {
  cursor: pointer;
}

.input-message {
  font-size: 0.95rem;
  margin-right: 10px !important;
  background-color: #FFFFFF !important;
  border: 1px solid #E4E4E4 !important;
  border-radius: 6px !important;
  &.disabled {
   background: $color-disabled !important;
  }

}

.send-button {
  height: 40px !important;
}

.fly-enter-active, .fly-leave-active {
  transition: all 0.5s ease;
}
.fly-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.chat-panel-elevated {
  margin: 2px;
  box-shadow: 0px 4px 16px 0px #0000001A;
}

</style>
